export default __webpack_public_path__ + "static/media/CapaPartners.b91a267b.svg";